const getDefaultCover = (color: string = '#FFFFFF') => {
  try {
    // Remove the # and get the filename
    const fileName = color.replace('#', '');
    // Import the image dynamically
    return new URL(
      `../assets/images/default-covers/${fileName}.jpg`,
      import.meta.url,
    ).href;
  } catch (error) {
    // Return default image in case of error
    return new URL(
      '../assets/images/default-covers/FFFFFF.jpg',
      import.meta.url,
    ).href;
  }
};

export default getDefaultCover;
